import { RollingPeriod } from '@/globalTypes';

export const complianceLimitsLabels: { [key: string]: string } = {
  SOW_180: 'Source of Wealth',
  KYC_180: 'KYC',
  CRA_DEPOSIT_90: 'CRA Deposit',
  RG_CRA_DEPOSIT_30_MEDIUM: 'RG CRA Deposit (Medium)',
  RG_CRA_DEPOSIT_30_HIGH: 'RG CRA Deposit (High)',
  RG_CRA_DEPOSIT_30_VERY_HIGH: 'RG CRA Deposit (Very High)',
  RG_CRA_NET_DEPOSIT_1K_INFINITE: 'RG CRA Net Deposit 1K',
  RG_NET_DEPOSIT_LIMIT: 'RG Net Deposit Limit',
};

export const getPeriodLabel = (rollingPeriod: RollingPeriod) => {
  const { period, periodType } = rollingPeriod;

  if (periodType === 'Finite') {
    return period;
  }

  return periodType;
};
